/* eslint-disable react-hooks/exhaustive-deps */
import { Formik, Form } from 'formik';
import React, { useEffect, useState } from 'react';
import BeigeButton from '../../../atoms/buttons/BeigeButton';
import { backendErrorMessageProcessor } from '../../../molecules/messageManager/backendErrorMessageProcessor';
import useBackendErrorsMessages from '../../../molecules/messageManager/useBackendErrorsMessages.js';
import { createMessageSlice } from '../../../../store/slices/createMessageSlice.js';
import postServiceForImg from '../../../../services/post_services/postServiceForImg.js';
import Loading from '../../../molecules/Loading.jsx';
import useCustomHomeModalData from './useCustomHomeModalData.js';
import CustomHomeModalAdminMapFormData from './CustomHomeModalAdminMapFormData.jsx';
import getService from '../../../../services/get_services/getService.js';
import HomeCustomModal from '../../../molecules/modals/first_time_modal_home/first-time-custom-modal/HomeCustomModal.jsx';
import { Button } from 'react-bootstrap';

export const BASE_URL_IMG = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_API_DEV_IMG_BASE_URL
  : process.env.REACT_APP_API_PROD_IMG_BASE_URL;

const CutomHomeModalAdmin = () => {
  const { customModalHomeFormMessages, customModalHomeFormButtons } = useCustomHomeModalData();
  const { backendErrors } = useBackendErrorsMessages();
  const { addMessage } = createMessageSlice();
  const [subbmitingForm, setSubbmitingForm] = useState(false);
  const [gettingDetails, setGettingDetails] = useState(false);
  const [showFirstTimeModalHome, setShowFirstTimeModalHome] = useState(false);
  const [initialFormValues, setInitialFormValues] = useState({ img: '', active: false });

  const getModalHomeDetails = async () => {
    setGettingDetails(true);
    const url = '/modal-home/get-details';
    const response = await getService(url);

    if (!response.success) {
      const errorsTranslated = backendErrorMessageProcessor(backendErrors, response.errors);
      addMessage({ type: 'error', content: errorsTranslated });
      return;
    }

    const homeModalDetails = response?.data?.homeModalDetails || null;
    setInitialFormValues({
      img: homeModalDetails?.imgUrl || '',
      active: homeModalDetails?.active ?? false
    });
    setGettingDetails(false);
  };

  const handleSubmit = async (values) => {
    setSubbmitingForm(true);
    const payload = { ...values };

    // Si 'img' es un File (nuevo upload), se envia como tal.
    if (values.img instanceof File) {
      // No cambia nada, el backend lo procesa como FormData en postServiceForImg
    } else if (typeof values.img === 'string') {
      // Si es una URL ya existente, se asigna a imgUrl para la base de datos
      payload.imgUrl = values.img;
      delete payload.img; // se elimina para que no se procese como archivo
    }

    const url = '/modal-home/set-img';
    const response = await postServiceForImg(url, payload);

    if (!response.success) {
      const errorsTranslated = backendErrorMessageProcessor(backendErrors, response.errors);
      addMessage({ type: 'error', content: errorsTranslated });
    } else {
      addMessage({
        type: 'success',
        content: customModalHomeFormMessages.custom_home_modal_admin_image_setting_successfull
      });
      await getModalHomeDetails();
    }
    setSubbmitingForm(false);
  };

  useEffect(() => {
    getModalHomeDetails();
  }, []);

  return (
    <div className='newsletter-template home-modal'>
      {gettingDetails || !initialFormValues
        ? (
          <div className='sending-emails-box'>
            <Loading message='custom-home-modal-admin-getting-details' />
          </div>
        )
        : (
          <div>
            <Formik
              initialValues={initialFormValues}
              enableReinitialize
              onSubmit={handleSubmit}
            >
              {({ values, setFieldValue }) => (
                <Form className='form'>
                  <CustomHomeModalAdminMapFormData
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                  <div className='form-button'>
                    <BeigeButton type='submit' disabled={subbmitingForm}>
                      {customModalHomeFormButtons.custom_home_modal_admin_boton_accept}
                    </BeigeButton>
                  </div>
                  {subbmitingForm && (
                    <p style={{ color: 'blue', marginTop: '10px' }}>
                      {customModalHomeFormMessages.custom_home_modal_admin_subbmiting_message}
                    </p>
                  )}
                </Form>
              )}
            </Formik>
            <div className='centered'>
              <Button style={{ width: '30%' }} variant='outline-dark' onClick={() => setShowFirstTimeModalHome(true)}>
                {customModalHomeFormButtons.custom_home_modal_admin_boton_show_modal}
              </Button>
            </div>
          </div>
        )}
      {showFirstTimeModalHome && (
        <HomeCustomModal
          modalImgUrl={initialFormValues.img !== '' ? `${BASE_URL_IMG}${initialFormValues.img}` : ''}
          showFirstTimeModalHome={showFirstTimeModalHome}
          setShowFirstTimeModalHome={setShowFirstTimeModalHome}
        />
      )}
    </div>
  );
};

export default CutomHomeModalAdmin;
